// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3H7aq","current":"style_current__mcXDJ","arrow":"style_arrow__3KxuU"};